import { DatasetBase, Dimension, OTHER_GROUP_ID } from '@core/reports-types';

export const buildDetailsDimensionsData = (dataset: DatasetBase, target: [number, number]) => {
  const primary = <Dimension>dataset.getDataAt([target[0] + 1, 0]);
  let secondary = <Dimension | Dimension[] | undefined>dataset.getDataAt([0, target[1] + 1]);
  if (!Array.isArray(secondary) && secondary?.id === OTHER_GROUP_ID) {
    const raw = dataset.parent!.getRawData()!;
    secondary = raw[0].slice(target[1] + 1);
  }
  return { primary, secondary, dataset };
};
